import type { TranslationTree } from '../../types';

export const profile: TranslationTree = {
  profile: {
    hero: {
      badge: 'Personal workspace',
      title: 'Welcome, {{name}}',
      subtitle: 'Personalize your ToolLife experience and keep your access secure.',
      emailLabel: 'Email address',
      anonymous: 'user',
    },
    overview: {
      title: 'Profile & access',
      description: 'Account information and active modules.',
      emailLabel: 'Login email',
      emailFallback: 'Not provided',
      modulesTitle: 'Enabled modules',
      modulesHelper: 'These accesses define which features are available to you.',
      modulesCount: '{{count}} module(s)',
      modulesEmpty: 'No module is currently enabled for your account.',
    },
    modules: {
      chip: {
        traceability: 'Traceability',
        analytics: 'Analytics',
        machineLearning: 'Predictive maintenance',
      },
    },
    preferences: {
      title: 'Interface preferences',
      description: 'Tune the appearance and language of the app.',
      themeLabel: 'Theme',
      languageLabel: 'Language',
    },
    security: {
      title: 'Account security',
      description: 'Update your password and protect your credentials.',
    },
    password: {
      title: 'Change password',
      fields: {
        current: {
          label: 'Current password',
          placeholder: 'Enter your current password',
        },
        new: {
          label: 'New password',
          placeholder: 'Choose a new password',
        },
        confirm: {
          label: 'Confirm password',
          placeholder: 'Confirm the new password',
        },
      },
      actions: {
        submit: 'Save new password',
        submitting: 'Saving…',
      },
      status: {
        success: 'Your password has been updated.',
      },
      errors: {
        mismatch: 'The new password and its confirmation do not match.',
        default: 'Unable to update the password.',
        client: 'User session not found. Please sign in again.',
      },
    },
  },
};
